import { useAuth } from 'context'
import { useEffect, useState } from 'react'
import { CompanyThemeService, ErrorConstant } from 'utility'

export const GetCompnayTheme = () => {
    const [data, setData] = useState({})
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const { user } = useAuth()
    const fetchData = async () => {
        try {
            setLoading(true)
            const list = await CompanyThemeService.getCompanyTheme(user.CompanyId)
            setData(list)
        } catch {
            setError(ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const refetch = () => {
        fetchData()
    }

    return { data, setData, error, loading, refetch }
}
